import { useMemo } from 'react';

import { css, Global, useTheme } from '@emotion/react';
import { Box, Paper } from '@mui/material';

import { pickTextColorBasedOnBgColorSimple } from '../../utils';
import { FooterScorenco } from '../FooterScorenco';

export const WidgetsStyle = ({ widget, children }) => {
  const theme = useTheme();
  const customizeTheme = useMemo(() => {
    if (
      !widget?.settings?.background_color ||
      !widget?.settings?.color ||
      !widget?.settings?.font_color
    ) {
      return undefined;
    }

    return css`
      --snc-palette-primary-main: ${widget?.settings.color};
      --snc-palette-primary-contrastText: ${pickTextColorBasedOnBgColorSimple(
        widget?.settings.color,
        '#ffffff',
        '#000000'
      )};
      --snc-palette-text-primary: ${widget?.settings.font_color};
      --snc-palette-background-default: ${widget?.settings.background_color};
      --snc-palette-secondary-main: ${widget?.settings.color};
    `;
  }, [widget?.settings?.background_color]);

  const style = {
    globals: css`
      body {
        --color-text-base: ${widget?.settings?.font_color};
        color: ${widget?.settings?.font_color};
        background: transparent;
      }
    `,
  };

  return (
    <>
      <Global styles={style.globals} />
      <Paper
        variant="bordered"
        sx={{ alignItems: 'flex-start', p: 0, overflow: 'hidden' }}
        css={customizeTheme}
      >
        {widget?.title && (
          <Box
            sx={{
              backgroundColor: theme.vars.palette.primary.main,
              width: '100%',
              textAlign: 'center',
              color: theme.vars.palette.primary.contrastText,
              padding: '0.5rem 0',
              fontWeight: 700,
            }}
          >
            {widget?.title}
          </Box>
        )}
        {children}
        <FooterScorenco />
      </Paper>
    </>
  );
};
